import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'boma-animation',
  templateUrl: './boma-animation.component.html',
  styleUrls: ['./boma-animation.component.scss'],
})
export class BomaAnimationComponent implements OnInit {
  @Input() size = 150;
  @Input() animPath = '/assets/lottie/no-results.json'; // does not work
  @Input() style = '';

  options: AnimationOptions;

  constructor() {}
  ngOnInit(): void {
    this.options = {
      path: this.animPath,
    };
  }
}
